<script src="pages/controlTables/codes/codes.component.ts"></script>
<app-modal></app-modal>
@if (base.userInfo !== undefined) {
  <span id="navbarContainer">
    <app-navbar></app-navbar>
  </span>
}


